import { NavigationBarAlertService } from './services/navigation_bar_alert_service';
import { NavigationHistoryStack } from './services/navigation_history_stack';
import { INavigationState } from '../nav_bar_interfaces';
import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';

export class AppNavBarComponent implements angular.IComponentOptions {
  public templateUrl: string = 'ui-ng-navbar/src/app_nav_bar/app_nav_bar.html';
  public controller: any = AppNavBarController;
  public transclude: any = {
    rightButtonSlot: '?appNavRightButton',
    leftButtonSlot: '?appNavLeftButton'
  };
  public bindings: any = {
    title: '@',
    allowBack: '<',
    onBack: '&?'
  };
}

export class AppNavBarController {
  private title: string;
  private allowBack: boolean;
  private backButtonTheme: string;
  private onBack: Function;

  constructor(
    private ngNavigationHistoryStack: NavigationHistoryStack,
    private appConfigModel: any,
    private ngNavigationBarAlertService: NavigationBarAlertService,
    private phxAxTitleAnnouncerDelegate: any
  ) {
    this.backButtonTheme = this.appConfigModel.navIconTheme() || 'primary';
  }

  $onInit() {
    this.phxAxTitleAnnouncerDelegate.updateTitle(this.title);
  }

  goBack(): void {
    if (_4.isFunction(this.onBack)) {
      this.onBack();
    } else {
      const previousURI = this.goBackURI();
      window['hosting']['kernel'].processes.history.goBackCommit();
      window.location.assign(previousURI);
    }
  }

  goBackURI(): string {
    return window['hosting']['kernel'].processes.history.goBackURI();
  }

  get backgroundClassString(): string {
    if (this.ngNavigationBarAlertService.alertStatus) {
      return `clr-red_30-bkg clr-white-txt`;
    }
    return `university-primary-bkg`;
  }

  get textClassString(): string {
    if (this.ngNavigationBarAlertService.alertStatus) {
      return `clr-white-txt`;
    }
    return `university-primary-text`;
  }

  showBackButton(): boolean {
    return _4.isFunction(this.onBack) || (this.allowBack && !this.ngNavigationHistoryStack.isNavigationHistoryEmpty);
  }

  isMobile(): boolean {
    return PlatformUtility.isMobile();
  }

  isTitleEmpty(): boolean {
    return !_4.isEmpty(this.title);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-navbar/src/app_nav_bar/app_nav_bar.ts